/**
 * App selector functions
 */

import { createSelector } from 'reselect';

const appReducer = (state) => state.get('appReducer');

/**
 * Retrieves logged in state from app reducer
 */
export const loggedInSelector = createSelector(appReducer, (state) =>
  state.get('isLoggedIn'),
);

/**
 * Retrieves SSO logged in state from app reducer
 */
export const ssoLoggedInSelector = createSelector(appReducer, (state) =>
  state.get('isSSOLoggedIn'),
);

/**
 * Retrieves current user state from app reducer
 */
export const currentUserSelector = createSelector(appReducer, (state) =>
  state.get('currentUser').toJS(),
);

export const required2FASelector = createSelector(appReducer, (state) =>
  state.get('is2FARequired'),
);
